export const FUNCIONARIOS = {
  label: 'Por Funcionários',
  value: 'FUNCIONARIOS',
  numberValue: 0,
};

export const PREDIOS = {
  label: 'Por Prédios',
  value: 'PREDIOS',
  numberValue: 1,
};

const SYSTEM_ADHERENCE_DATA_ENUM = [FUNCIONARIOS, PREDIOS];

export default SYSTEM_ADHERENCE_DATA_ENUM;
